module.exports = "pegasus/assets/fruit-bg.jpg";